import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';
import { MEETING_ANALYSIS_NAMESPACE_NAME_INJECTION_TOKEN$ } from '@galaxy/meeting-analysis/static';

@Component({
  templateUrl: './visibility-info-dialog.component.html',
  styleUrls: ['./visibility-info-dialog.component.scss'],
  selector: 'meeting-analysis-visibility-info-dialog',
  imports: [CommonModule, MatDialogModule, MatButtonModule, TranslateModule],
})
export class VisibilityInfoDialogComponent {
  readonly namespaceName$ = inject(MEETING_ANALYSIS_NAMESPACE_NAME_INJECTION_TOKEN$);

  constructor(
    public dialogRef: MatDialogRef<VisibilityInfoDialogComponent>,
  ) {}

}
